import { useEffect, useState } from 'react';

function getReturnUrl() {
  const { pathname, search } = window.location;
  return encodeURIComponent(`${pathname}${search}`);
}

// Gates a form behind login when `requireLogin` is set.
export default function useFormAuthGate({ requireLogin, me, appSession }) {
  const [state, setState] = useState(() => {
    if (!requireLogin) return { status: 'ready', user: null };
    if (!appSession.isLoggedIn()) return { status: 'anonymous', user: null };
    return { status: 'checking', user: null };
  });

  useEffect(() => {
    if (state.status !== 'checking') return;
    let cancelled = false;

    Promise.resolve(me.user || me.fetch('boot'))
      .then((user) => {
        if (cancelled) return;
        setState(
          user ? { status: 'ready', user } : { status: 'anonymous', user: null }
        );
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'anonymous', user: null });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const returnUrl = getReturnUrl();

  return {
    ...state,
    signupUrl: `/signup?return=${returnUrl}`,
    loginUrl: `/login?return=${returnUrl}`,
  };
}
